import React from 'react';
// import TrackerGame from '../components/TrackerGame/TrackerGame';

const Game = () => {
  return (
    <div className="game-page">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center py-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Game Coming Soon!</h1>
          <p className="text-lg text-gray-600 mb-8">
            The interactive 3D game is currently in development and will be available soon.
          </p>
          <div className="bg-gray-100 rounded-lg p-8 max-w-md mx-auto">
            <div className="text-6xl mb-4">🎮</div>
            <p className="text-gray-700">
              We're working hard to bring you an amazing gaming experience!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Game; 